import { SelectField } from '@components/molecules/SelectField'
import { scopedTranslation } from '@utils/I18n'

import useSupporterFilteringStore from '../filter-supporters/stores/useSupporterFilteringStore'

const tShared = scopedTranslation('shared')

function SortSupporters() {
  const currentSort = useSupporterFilteringStore((state) => state.currentSort)
  const sortOptions = useSupporterFilteringStore((state) => state.sortOptions)
  const setCurrentSort = useSupporterFilteringStore((state) => state.setCurrentSort)

  return (
    <SelectField
      name="sort_by"
      label={tShared('labels.sort_by')}
      options={sortOptions}
      value={currentSort}
      onValueChange={setCurrentSort}
    />
  )
}

export default SortSupporters
